const FS_HAS_DOTDIGITAL = "fs_has_dotdigital";
export default class Dotdigital {
    static setHasDotdigital(value) {
        if (value) {
            localStorage.setItem(FS_HAS_DOTDIGITAL, "true");
        }
        else {
            localStorage.removeItem(FS_HAS_DOTDIGITAL);
        }
    }
    static getHasDotdigital() {
        const hasDotdigital = localStorage.getItem(FS_HAS_DOTDIGITAL);
        return hasDotdigital === "true";
    }
}
//# sourceMappingURL=dotdigital.js.map